import { Button, Group, LoadingOverlay, type GroupProps } from '@mantine/core'
import { IconCheck, type Icon } from '@tabler/icons-react'
import { type FC, type FormHTMLAttributes, type ReactNode } from 'react'

export interface FormProps extends FormHTMLAttributes<HTMLFormElement> {
  buttons?: ReactNode | boolean
  isSaving?: boolean
  isValid?: boolean
  SubmitIconComponent?: Icon
  submitLabel?: string
  buttonGroupProps?: GroupProps
}

export const Form: FC<FormProps> = ({
  buttons = true,
  children,
  isSaving,
  isValid = true,
  onSubmit,
  style,
  SubmitIconComponent = IconCheck,
  submitLabel = 'Save',
  buttonGroupProps = {},
  ...formProps
}) => (
  <form
    {...formProps}
    onSubmit={onSubmit}
    style={{ position: 'relative', ...style }}
  >
    <LoadingOverlay visible={isSaving} />
    {children}
    {buttons ? (
      <Group
        pt='md'
        position='right'
        {...buttonGroupProps}
      >
        {buttons === true ? (
          <Button
            color='green'
            data-autofocus
            disabled={isSaving || !isValid}
            leftIcon={<SubmitIconComponent size={18} />}
            loading={isSaving}
            type='submit'
          >
            {submitLabel}
          </Button>
        ) : (
          buttons
        )}
      </Group>
    ) : null}
  </form>
)
